import gql from "graphql-tag";

// Query
export const GET_CARDS_BY_USER = gql`
  query cards($customer_id: String!) {
    cards(customer_id: $customer_id) {
      id
      brand
      holder_name
      first_digits
      last_digits
      valid
      expiration_date
    }
  }
`;

// Mutations
export const SET_CARD = gql`
  mutation createCard(
    $card_number: String!
    $card_expiration_date: String!
    $card_holder_name: String!
    $card_cvv: String!
    $customer_id: String!
    $card_hash: String
    $card_default: Boolean!
    $external_id: String!
  ) {
    createCard(
      card: {
        card_number: $card_number
        card_expiration_date: $card_expiration_date
        card_holder_name: $card_holder_name
        card_cvv: $card_cvv
        customer_id: $customer_id
        card_hash: $card_hash
        card_default: $card_default
        external_id: $external_id
      }
    ) {
      id
      brand
      holder_name
      first_digits
      last_digits
      valid
      expiration_date
    }
  }
`;
